// import React, { useState } from 'react';
// import { Layout, Menu, Button, Row, Col, Typography, Drawer, Space } from 'antd';
// import { 
//   HomeOutlined, 
//   TeamOutlined, 
//   MedicineBoxOutlined, 
//   BookOutlined, 
//   PhoneOutlined,
//   MenuOutlined 
// } from '@ant-design/icons';
// import { motion } from 'framer-motion';
// import './Header.css';
// import { Link } from 'react-router-dom';

// const { Header } = Layout;
// const { Title, Text } = Typography;

// const AppHeader = () => {
//   const [visible, setVisible] = useState(false);

//   const showDrawer = () => {
//     setVisible(true);
//   };

//   const onClose = () => {
//     setVisible(false);
//   };

//   const menuItems = [
//     { key: 'home', label: <a href='/'>Home</a>, icon: <HomeOutlined />   },
//     { key: 'about', label: <a href='/about' >About Us</a> , icon: <TeamOutlined /> },
//     { key: 'services', label: <a href='/services'>Services </a>, icon: <MedicineBoxOutlined />  },
//     { key: 'blog', label: <a href='/blog'>Blog</a>, icon: <BookOutlined /> },
//   ];

//   return (
//     <Header className="app-header">
//       <Row justify="space-between" align="middle" style={{ width: '100%' }}>
//         <Col>
//           <motion.div
//             initial={{ opacity: 0, x: -20 }}
//             animate={{ opacity: 1, x: 0 }}
//             transition={{ duration: 0.8 }}
//           >
//             <Space align="center">
//               <Title level={3} style={{ color: 'white', margin: 0 }}>
//                 Prime Health Care Consultancy
//               </Title>
//             </Space>
//           </motion.div>
//         </Col>

//         <Row className='desktop-button' > 
//           <Col><Menu
//             theme="dark"
//             mode="horizontal"
          
//             items={menuItems}
//             className="header-menu"
//           />
//           </Col>
//           <Col>
//           <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
//             <Button type="primary" size="large" id='desktop-button'> <a  href='/contact'>Get Consultation</a></Button>
//           </motion.div>
//           </Col>
//         </Row>

          

//         <Col className="mobile-menu">
//           <Button 
//             type="text" 
//             icon={<MenuOutlined style={{ fontSize: '20px', color: 'white' }} />} 
//             onClick={showDrawer}
//           />
//         </Col>
//       </Row>

//       {/* Mobile Drawer */}
//       <Drawer
//         title="Menu"
//         placement="right"
//         onClose={onClose}
//         open={visible}
//         width={300}
//         bodyStyle={{ padding: 0 }}
//       >
//         <Menu
//           mode="vertical"
//           // defaultSelectedKeys={['home']}
//           items={menuItems}
//           style={{ borderRight: 0 }}
//         />
//         <div style={{ padding: '16px' }}>
//           <Button type="primary" block size="large"><a  href='/contact'>Get Consultation</a></Button>
//         </div>
//       </Drawer>
//     </Header>
//   );
// };

// export default AppHeader;










import React, { useState } from 'react';
import { Layout, Menu, Button, Row, Col, Typography, Drawer, Space } from 'antd';
import { 
  HomeOutlined, 
  TeamOutlined, 
  MedicineBoxOutlined, 
  BookOutlined, 
  PhoneOutlined,
  MenuOutlined 
} from '@ant-design/icons';
import { motion } from 'framer-motion';
import './Header.css';
import { Link } from 'react-router-dom';

const { Header } = Layout;
const { Title, Text } = Typography;

const AppHeader = () => {
  const [visible, setVisible] = useState(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const menuItems = [
    { key: 'home', label: <a href='/'>Home</a>, icon: <HomeOutlined /> },
    { key: 'about', label: <a href='/about' >About Us</a> , icon: <TeamOutlined /> },
    { key: 'blog', label: <a href='/blog'>Blog</a>, icon: <BookOutlined /> },
    { key: 'services', label: <a href='/services'>Services </a>, icon: <MedicineBoxOutlined />  },
  ];

  return (
    <Header className="app-header">
      <Row justify="space-between" align="middle" style={{ width: '100%' }}>
        <Col>
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Space align="center">
              <Title level={3} style={{ color: 'white', margin: 0 }}>
                Prime Health Care Consultancy
              </Title>
            </Space>
          </motion.div>
        </Col>

        {/* Desktop Menu and Button - Fixed structure */}
        <Col className="desktop-menu">
          <Row align="middle" gutter={16}>
            <Col>
              <Menu
                theme="dark"
                mode="horizontal"
                items={menuItems}
                className="header-menu"
                style={{ lineHeight: '64px', border: 'none', background: 'transparent' }}
              />
            </Col>
            <Col>
              <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                <Button type="primary" size="large">
                  <a href='/contact'>Get Consultation</a>
                </Button>
              </motion.div>
            </Col>
          </Row>
        </Col>

        {/* Mobile Menu Button */}
        <Col className="mobile-menu">
          <Button 
            type="text" 
            icon={<MenuOutlined style={{ fontSize: '20px', color: 'white' }} />} 
            onClick={showDrawer}
          />
        </Col>
      </Row>

      {/* Mobile Drawer */}
      <Drawer
        title="Menu"
        placement="right"
        onClose={onClose}
        open={visible}
        width={300}
        bodyStyle={{ padding: 0 }}
      >
        <Menu
          mode="vertical"
          items={menuItems}
          style={{ borderRight: 0 }}
        />
        <div style={{ padding: '16px' }}>
          <Button type="primary" block size="large">
            <a href='/contact'>Get Consultation</a>
          </Button>
        </div>
      </Drawer>
    </Header>
  );
};

export default AppHeader;